<template>
  <div>
    <swiper :options="swiperOption" class="swiper-box" >
      <swiper-slide class="swiper-item" v-for="item in listimages" :key="item.index">
        <img :src="item.replace('.resized.{bucket}', '')" width="240px"/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<style lang="scss">
  .swiper-container {
    width: 320px;
    height: 320px;
    padding: 40px;
  }
  .swiper-slide {
    background-position: 50%;
    background-size: cover;
    width: 100%;
  }
</style>

<script>
export default {
  name: 'images-resources',
  props: ['listimages'],
  data () {
    return {
      swiperOption: {
        effect: 'flip',
        grabCursor: true,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/previews/ImagesResources.vue